export const colors = {
  primary: {
    main: '#4f46e5',
    light: '#797bfcff',
    dark: '#3730a3',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#6b7280',
    light: '#9ca3af',
    dark: '#4b5563',
  },
  background: {
    default: '#eeeef5',
    paper: '#fafafa',
  },
  text: {
    primary: '#1a202c',
    secondary: '#6b7280',
  },
  divider: '#e5e7eb',
  action: {
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(79, 70, 229, 0.08)',
    active: '#4f46e5',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  success: {
    main: '#10b981',
    light: '#d1fae5',
    dark: '#065f46',
  },
  error: {
    main: '#ef4444',
    light: '#fecaca',
    dark: '#dc2626',
  },
  warning: {
    main: '#f59e0b',
    light: '#fffbeb',
    dark: '#d97706',
  },
  info: {
    main: '#3b82f6',
    light: '#8bbdff',
    dark: '#1d4ed8',
  },
  common: {
    white: '#ffffff',
    black: '#000000',
  },
};
